import React from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';

import CheckIcon from '@liquidweb-dev/undercurrent/icons/lucide/Check';

const NoAlerts = () => (
	<Stack flex={1} justifyContent="center" alignItems="center" spacing={200}>
		<CheckIcon
			sx={(theme) => ({
				color: theme.vars.palette.uc.icon.weak,
				width: theme.size.md,
				height: theme.size.md,
			})}
		/>
		<Typography
			variant="body-md"
			sx={(theme) => ({
				color: theme.vars.palette.uc.text.weak,
			})}
		>
			No alerts
		</Typography>
	</Stack>
);

export default NoAlerts;
